var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SAIMessage',{attrs:{"variant":"negative"}},[_vm._t("default",function(){return [_vm._v(" Please complete the mandatory fields highlighted in red below. ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }